import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Config } from '../app.config';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit {

  public content = '';

  constructor(private http: HttpClient) { }

  ngOnInit() {
    this.load();
  }

  async load() {
    try {
      let content:any = await this.http.get(Config.backend + '/page/72&?_format=json').toPromise();
      this.content = content[0].body;      
    }
    catch(error) {
      console.log("ERROR:", error)
      this.content = "error loading content";
    }
  }

}
